module.exports = __webpack_public_path__ + "static/img/Bitmap_1.1212908.png";


//////////////////
// WEBPACK FOOTER
// ./static/Bitmap_1.png
// module id = KJb5
// module chunks = 7